// React
import React from "react";
// Components
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
import AgencyReportsOptions from "common/ui/components/nav/AgencyReportsOptions";
import SettingsOptions from "common/ui/components/nav/SettingsOptions";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./HomeView.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class AgencyHomeView extends React.Component {
    render() {
        return (React.createElement(Page, null,
            React.createElement(PageHeading, { reportName: "Agency" }),
            React.createElement(PageContainer, null,
                React.createElement("div", { className: styles.container },
                    React.createElement(AgencyReportsOptions, { agencyId: this.props.params.agencyId }),
                    React.createElement(SettingsOptions, { params: this.props.params })))));
    }
}
